package team.platforma.aicombo.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.window
import kotlinx.coroutines.await

actual class ClipboardAPI actual constructor() {
    @Composable
    actual fun available(): Boolean {
        return remember {
            js("navigator && navigator.clipboard && window.isSecureContext") as? Boolean ?: false
        }
    }

    actual suspend fun pasteFromClipboard(): String {
        return try {
            window.navigator.clipboard.readText().await()
        } catch (e: Throwable) {
            console.error("Clipboard read failed", e)
            ""
        }
    }
}